import { useEffect } from 'react';

import { motion } from 'framer-motion';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { cn } from 'components/lib/utils';

import { SetupChecklistContentSection } from './ContentSection/Container';
import { SetupChecklistHeader } from './Header';

export const SetupChecklistContent: React.FC = () => {
  const {
    isExpanded,
    toggleChecklistExpandedState,
    categories,
    resetSelectedCategory
  } = useChecklistState();

  useEffect(() => {
    if (!isExpanded) {
      toggleChecklistExpandedState(true);
    }

    return () => {
      toggleChecklistExpandedState(false);
    };
  }, []);

  useEffect(() => {
    resetSelectedCategory();
  }, [categories]);

  return (
    <div
      className={cn(
        'setup-checklist-container fixed bottom-9 right-7 bg-[#F9F9FA] text-black rounded-lg shadow-base-shadow border border-base-border w-[330px] select-none'
      )}
      style={{ zIndex: 60 }}
    >
      <SetupChecklistHeader />
      <motion.div
        layout
        initial={{ height: 0 }}
        animate={{ height: isExpanded ? 'auto' : 0 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
        className="overflow-hidden bg-gray-100 rounded"
      >
        <SetupChecklistContentSection />
      </motion.div>
    </div>
  );
};
